<template>
  <div
    class="border-b-[1] border-solid fixed top-[0] left-[0] right-[0] z-[999]"
    id="navigation"
    :class="{ 'top-nav': isTop, black: type == 1 && !isTop }"
    :style="{ borderColor: borderColor }"
  >
    <div class="w-[1200] mx-[auto] my-[13] flex-center relative">
      <div class="flex">
        <i class="iconfont-logo logoIcon-yancheng t-[#ffffff] t-[40]"></i>
        <div class="pl-[20] platform-text relative">
          <p class="flex itmes-center items-center">
            <span class="t-[22] pr-[5] font-700 t-[#ffffff] platform"
              >供应链金融平台</span
            >
            <span
              class="t-[#0048FF] font-600 bg-[#fff] rounded-[2] t-[12] px-[6] py-[3] city"
              >盐城市</span
            >
          </p>
          <p class="t-[15] t-[#fff] platform-desc">
            数字一体化电子保函综合服务平台
          </p>
        </div>
      </div>
      <a
        class="t-[#fff] login-txt cursor-pointer no-underline"
        :href="domain"
        target="_blank"
      >
        <i class="icon t-[16]">&#xe6c4;</i>
        <span class="t-[14] pl-[2]">{{ realName ?  realName : '登录' }}</span>
      </a>

      <div class="absolute left-[0] bottom-[-50] t-[15] flex navigation-list">
        <p
          @click="push({ path: '/' })"
          :class="{ active: index == 0 }"
          class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
        >
          首页
        </p>
        <el-dropdown @command="handleCommand" placement="bottom">
          <p
            href="#/"
            class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
            :class="{ active: index == 1 }"
          >
            解决方案
          </p>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/receive"
              ><span :class="{ activeColor: activeColor == '/receive' }"
                >应收账款融资</span
              ></el-dropdown-item
            >
            <el-dropdown-item command="/advance"
              ><span :class="{ activeColor: activeColor == '/advance' }"
                >预付款融资</span
              ></el-dropdown-item
            >
            <el-dropdown-item command="/repertory"
              ><span :class="{ activeColor: activeColor == '/repertory' }"
                >存货融资</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand1" placement="bottom">
          <p
            class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
          >
            更多服务
          </p>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a"
              ><span :class="{ activeColor: activeColor == 'a' }"
                >电子保函</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <p
          :class="{ active: index == 4 }"
          class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
          @click="$router.push('/news')"
        >
          政策资讯
        </p>
        <a
          href="https://open.ycbaohan.com/#/"
          target="_blank"
          class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
          >开放平台</a
        >
        <p
          :class="{ active: index == 5 }"
          class="no-underline pt-[13] px-[24] cursor-pointer navigation-list-txt"
          @click="$router.push('/contract')"
        >
          关于我们
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { throttle } from "../assets/js/utils";
export default {
  mixins: [mixin],
  name: "dg-nav",
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    type: Number | String,
    borderColor: {
      type: String,
      default: "rgba(255,255,255,0.5)",
    },
  },
  watch: {
    top: {
      handler(value) {
        console.log(value);
        this.isTop = value;
      },
      immediate: true,
    },
  },
  data() {
    return {
      isTop: false,
      activeColor: "",
      domain: process.env.VUE_APP_DOMAIN,
      realName: "",
    };
  },
  methods: {
    getCurrent() {
      ajax.post({
        url: "/supplyChain/user/current",
        data: {
          type: "1",
        },
        self: this,
        success: (res) => {
          this.realName = res.user.realName || '';
        },
        fail: (err) => {
          console.log(err);
        },
      });
    },
    handleCommand(command) {
      this.$router.push(command);
    },
    handleCommand1() {
      window.open("https://www.ycbaohan.com/");
    },
    handleScroll() {
      let top = document.documentElement.scrollTop;
      if (this.top) return;
      if (top > 50) {
        this.isTop = true;
      } else {
        this.isTop = false;
      }
    },
  },
  mounted() {
    this.getCurrent();
  },
  created() {
    let _handleScroll = throttle(this.handleScroll, 200);
    // if (index != 1) {
    //   this.isPosition = true;
    // } else {
    //   this.isPosition = false;
    // }
    // if (this.index == 0 && document.documentElement.scrollTop > 150) {
    //   this.isScroll = true;
    // } else {
    //   this.isScroll = false;
    // }
    document.addEventListener("scroll", _handleScroll, true);
  },
};
</script>
<style scoped lang="less">
.text.light::after {
  background-color: #0048ff;
}

#navigation.top-nav .navigation-list {
  left: auto;
  top: 3px;
  bottom: auto;
  right: 77px;
}

#navigation .navigation-list-txt {
  color: #d0ddef;
}

#navigation .navigation-list-txt.active {
  color: #fff;
}

#navigation.top-nav .navigation-list-txt.active {
  color: #0048ff;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 48px;
    height: 2px;
    background-color: #0048ff;
  }
}

#navigation.black .navigation-list-txt.active {
  color: #303133;
}

#navigation.top-nav {
  transition: background-color 0.5s;
  background-color: #fff;
}

#navigation.top-nav .login-txt {
  position: relative;
  top: 2px;
}

#navigation.top-nav .navigation-list-txt,
#navigation.top-nav .login-txt,
#navigation.top-nav .platform,
#navigation.top-nav .platform-desc,
#navigation.black .platform-desc {
  color: #191a24;
}

#navigation.black .navigation-list-txt {
  color: #909399;
}

#navigation.top-nav .navigation-list-txt:hover,
#navigation.top-nav .logoIcon-yancheng,
#navigation.black .logoIcon-yancheng,
#navigation.black .platform {
  color: #0048ff;
}

#navigation.top-nav .platform-text::after {
  background-color: #ccc;
}

#navigation.black .platform-text::after {
  background-color: #80a3ff;
}

#navigation.black .login-txt {
  color: #191a24;
}

#navigation.black .city {
  color: #fff;
  background-color: #0048ff;
}

#navigation.top-nav .city {
  color: #fff;
  background-color: #0048ff;
}

.platform-text::after {
  content: "";
  display: block;
  position: absolute;
  left: 10px;
  top: 10%;
  width: 1px;
  height: 80%;
  background-color: #fff;
}
</style>
 <style>.border-b-\[1\] {
    border-bottom-width: 1px
}
.top-\[0\] {
    top: 0px
}
.left-\[0\] {
    left: 0px
}
.right-\[0\] {
    right: 0px
}
.z-\[999\] {
    z-index: 999
}
.w-\[1200\] {
    width: 1200px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.my-\[13\] {
    margin-top: 13px;
    margin-bottom: 13px
}
.t-\[\#ffffff\] {
    color: #ffffff
}
.t-\[40\] {
    font-size: 40px
}
.pl-\[20\] {
    padding-left: 20px
}
.t-\[22\] {
    font-size: 22px
}
.pr-\[5\] {
    padding-right: 5px
}
.t-\[\#0048FF\] {
    color: #0048FF
}
.bg-\[\#fff\] {
    background-color: #fff
}
.rounded-\[2\] {
    border-radius: 2px
}
.t-\[12\] {
    font-size: 12px
}
.px-\[6\] {
    padding-left: 6px;
    padding-right: 6px
}
.py-\[3\] {
    padding-top: 3px;
    padding-bottom: 3px
}
.t-\[15\] {
    font-size: 15px
}
.t-\[\#fff\] {
    color: #fff
}
.t-\[16\] {
    font-size: 16px
}
.t-\[14\] {
    font-size: 14px
}
.pl-\[2\] {
    padding-left: 2px
}
.bottom-\[-50\] {
    bottom: -50px
}
.pt-\[13\] {
    padding-top: 13px
}
.px-\[24\] {
    padding-left: 24px;
    padding-right: 24px
}
.border-solid {
    border-style: solid
}
.fixed {
    position: fixed
}
.flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center
}
.relative {
    position: relative
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.font-700 {
    font-weight: 700
}
.font-600 {
    font-weight: 600
}
.cursor-pointer {
    cursor: pointer
}
.no-underline {
    text-decoration: none
}
.absolute {
    position: absolute
}</style>